import ABCyaPhaser from '@abcya/abcya_phaser';
import SoundAssetKeys from './SoundAssetKeys';
import Phaser from 'phaser';

/** @type {Phaser.Sound.HTML5AudioSound} */
let theme = null;

/**
 * 
 * @param {Phaser.Scene} scene 
 */
export function setup(scene) {
  theme = ABCyaPhaser.Audio.createSound(scene);
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function playJingle(jingle, scene, fade = 0) {
  scene?.tweens.killTweensOf(theme);
  if (!theme.isPlaying || theme.currentMarker.name !== jingle)ABCyaPhaser.Audio.playSound(jingle, theme, scene !== null && scene !== undefined && fade > 0 ? 0 : 0.3, true);

  if (scene !== null && scene !== undefined && fade > 0) {
    scene.tweens.add({ targets: theme, duration: fade, props: { volume: 0.3 }, ease: Phaser.Math.Easing.Quadratic.Out });
  }
}

/**
 * 
 * @param {Phaser.Scene} scene you only need to pass in the scene if you want the fade to occur
 * @param {number} fade 
 * @returns 
 */
export function stopJingle(scene, fade = 0) {
  if (!theme.isPlaying) return;

  scene?.tweens.killTweensOf(theme);
  if (scene !== null && scene !== undefined && fade > 0) {
    scene.tweens.add({ targets: theme, duration: fade, props: { volume: 0 }, ease: Phaser.Math.Easing.Quadratic.In, onComplete: () => theme.stop() });
  }
  else {
    theme.stop();
  }
}